<script>
  import { meta, entities, entityData } from "./store.js";
  function flash(msg) {
    flashmsg = msg;
    setTimeout(() => {
      flashmsg = null;
    }, 3000);
  }

  function exp() {
    const time = $meta.stopwatch
      ? ($meta.stopwatch.state === "STOP"
          ? $meta.stopwatch.end
          : new Date().getTime()) - $meta.stopwatch.start
      : 0;
    const exportstr = [
      ["name", "laps", "time (sec)", "distance (m)", "split (sec/100m)"],
      ...$entities.map(name => {
        const lap = ($entityData[name] && $entityData[name].count) || 0;
        const timesec = time / 1000;
        const distance = lap * $meta.laps;
        const split = time / 10 / distance;
        return [name, lap, timesec, distance, split];
      })
    ]
      .map(arr => arr.join(", "))
      .join("\n");

    const file = new File([exportstr], "laps.csv", { type: "text/csv" });

    const link = document.createElement("a");
    link.style.display = "none";
    link.href = URL.createObjectURL(file);
    link.download = file.name;

    // It needs to be added to the DOM so it can be clicked
    document.body.appendChild(link);
    link.click();

    // To make this work on Firefox we need to wait
    // a little while before removing it.
    setTimeout(() => {
      URL.revokeObjectURL(link.href);
      link.parentNode.removeChild(link);
    }, 0);
  }
</script>

<style>
  button {
    padding: 1rem;
    border: 0px;
  }
</style>

<button on:click={exp}>Export</button>